import {IManagableObject} from "./IManagableObject";

export class ObjectGroupViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  //Count: number = 0;
  objects: number[] = [];

  ///workaround
  isMgmtOpen: boolean = false;
  mgmtxPos: number;
  mgmtyPos: number;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      //this.Count = data["count"];
      this.objects = data["objects"];
    }
  }

  static fromJS(data: any): ObjectGroupViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectGroupViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
